import { Link } from "@/base/component/link";
import { IconCheck, IconX } from "@tabler/icons-react";

export default function Difference() {
  return (
    <section id="difference" className="pb-8 bg-body-light dark:bg-body-dark">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12 px-4">
          <h2 className="font-bold mb-4 text-3xl md:text-5xl">
            Affordable but powerful SEO tool
          </h2>
          <p className="text-gray-600 dark:text-gray-300 text-lg md:text-xl">
            A more affordable but powerful and user-friendly alternative to
            expensive SEO tools.{" "}
            <Link
              href="/seo-ai-pal-vs-competitors#integration"
              className="text-primary"
            >
              See how we compare
            </Link>
            .
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Semrush Column */}
          <div className="bg-red-50 dark:bg-red-900/50 p-8 rounded-xl">
            <h3 className="text-2xl font-semibold text-red-600 dark:text-red-400 mb-8">
              Using Semrush
            </h3>

            <ul className="space-y-3">
              <NegativePoint text="Steep learning curve for beginners" />
              <NegativePoint text="Expensive monthly subscription (>140$)" />
              <NegativePoint text="Overwhelming data without clear actions" />
              <NegativePoint text="Time-consuming manual analysis" />
              <NegativePoint text="Complex interface with too many options" />
            </ul>
          </div>

          {/* SEO AI Pal Column */}
          <div className="bg-green-50 dark:bg-green-900/50 p-8 rounded-xl">
            <h3 className="text-2xl font-semibold text-green-600 dark:text-green-400 mb-8">
              Using SEO AI Pal
            </h3>

            <ul className="space-y-3">
              <PositivePoint text="Instant insights AI processed" />
              <PositivePoint text="Affordable payment option (~10$)" />
              <PositivePoint text="Actionable recommendations with prompts" />
              <PositivePoint text="Automated analysis saves hours of work" />
              <PositivePoint text="Simple, user-friendly interface" />
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

function NegativePoint({ text }: { text: string }) {
  return (
    <li className="flex items-start gap-3">
      <IconX className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" />
      <span className="text-gray-700 dark:text-gray-300">{text}</span>
    </li>
  );
}

function PositivePoint({ text }: { text: string }) {
  return (
    <li className="flex items-start gap-3">
      <IconCheck className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" />
      <span className="text-gray-700 dark:text-gray-300">{text}</span>
    </li>
  );
}
